export type VersionCheckerTranslations = {
  newVersionAvailable: string;
  refresh: string;
};

export const versionCheckerTranslations: VersionCheckerTranslations = {
  newVersionAvailable: 'Dostępna jest nowa wersja aplikacji.',
  refresh: 'Odśwież',
};
